import CookieHandler from "./CookieHandler";

class GeoLocation {
    locationCookieName: string;
    cookieLife: number;
    CookieHandler: CookieHandler;

    constructor() {
        this.locationCookieName = "currentLocation";
        this.cookieLife = 1; // 10 minutes
        this.CookieHandler = new CookieHandler();
    }

    /**
     * Get current position
     */
    getCurrentPosition(callback: (arg: string | object) => void) {
        if (this.CookieHandler.checkCookie(this.locationCookieName)) {
            return callback(
                JSON.parse(
                    this.CookieHandler.getCookie(this.locationCookieName),
                ),
            );
        } else {
            this.getCoordinates(callback);
        }
    }

    /**
     * Get coordinates
     */
    getCoordinates(callback: (arg: string | object) => void) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position): void => {
                    this.CookieHandler.setCookie(
                        this.locationCookieName,
                        JSON.stringify({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        }),
                        this.cookieLife,
                    );
                    return callback({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                },
                (error) => {
                    if (error.code === 3) {
                        // Timeout
                        return callback("error");
                    }
                    return callback("error");
                },
                {
                    timeout: 4000,
                },
            );
        } else {
            return callback("error");
        }
    }

    /**
     * Get distance between 2 locations
     */
    getDistance(
        lat1: number,
        lon1: number,
        lat2: number,
        lon2: number,
        unit: string,
    ): number {
        const radlat1 = (Math.PI * lat1) / 180;
        const radlat2 = (Math.PI * lat2) / 180;
        const theta = lon1 - lon2;
        const radtheta = (Math.PI * theta) / 180;
        let dist =
            Math.sin(radlat1) * Math.sin(radlat2) +
            Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist);
        dist = (dist * 180) / Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit === "K") {
            dist = dist * 1.609344;
        }
        if (unit === "N") {
            dist = dist * 0.8684;
        }

        return Math.round(dist * 10) / 10;
    }
}

export default GeoLocation;
